var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-breadcrumb',[_c('b-breadcrumb-item',{attrs:{"text":'Forms',"to":'/forms'}}),_c('b-breadcrumb-item',{attrs:{"text":'All Forms',"active":""}})],1),_c('forms-table',{attrs:{"requests":_vm.requests}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }